//libs
import React, { memo, useEffect, useState } from 'react';

//components
import MeasureWidth from 'shared/components/MeasureWidth';
import AppliedFiltersContainer from 'shared/components/AppliedFiltersV2/components/AppliedFiltersContainer';

//constants
import { FilterContainerStates } from './constants';

//selectors
import { getFilterWithNames } from 'shared/store/listingV2/selectors';
import { useSelector } from 'react-redux';

//types
interface IAppliedFiltersV2 {
  onFilterRemove: (key: string, id: string) => void;
  isFiltersExpanded: boolean;
  setIsFiltersExpanded: (state: boolean) => void;
  filtersWidth: number;
}

//constants
const FILTERS_DUMMY_WIDTH = -1;

function AppliedFiltersV2({
  onFilterRemove,
  isFiltersExpanded,
  setIsFiltersExpanded,
  filtersWidth,
}: IAppliedFiltersV2) {
  const filterWithNames = useSelector(getFilterWithNames);
  const [rowWidth, setRowWidth] = useState(FILTERS_DUMMY_WIDTH);
  const [currentFilterCount, setCurrentFilterCount] = useState(filterWithNames.length);

  const onWidthMeasured = (width: number) => {
    if (width <= filtersWidth) {
      setCurrentFilterCount(currentFilterCount);
      setRowWidth(width);
      return;
    }
    if (currentFilterCount === 1) {
      setRowWidth(width);
      return;
    }
    setCurrentFilterCount(currentFilterCount - 1);
  };

  useEffect(() => {
    if (filterWithNames.length > 0) {
      setCurrentFilterCount(filterWithNames.length);
      setRowWidth(FILTERS_DUMMY_WIDTH);
      setIsFiltersExpanded(true);
    }
    /* eslint-disable react-hooks/exhaustive-deps */
  }, [filterWithNames.length, filtersWidth]);

  const widthNotCalculated = rowWidth === FILTERS_DUMMY_WIDTH;

  if (filterWithNames.length === 0) return <div></div>;

  return (
    <>
      {isFiltersExpanded ? (
        <AppliedFiltersContainer
          type={FilterContainerStates.EXPANDED}
          filters={filterWithNames}
          setIsFiltersExpanded={setIsFiltersExpanded}
          onFilterRemove={onFilterRemove}
        />
      ) : __BROWSER__ && widthNotCalculated ? (
        <MeasureWidth onMeasured={onWidthMeasured}>
          <AppliedFiltersContainer
            type={FilterContainerStates.COLLAPSED}
            maxFilterToShow={currentFilterCount}
            showTrailingIcon={true}
            filters={filterWithNames}
            setIsFiltersExpanded={setIsFiltersExpanded}
            onFilterRemove={onFilterRemove}
          />
        </MeasureWidth>
      ) : (
        <AppliedFiltersContainer
          type={FilterContainerStates.COLLAPSED}
          maxFilterToShow={currentFilterCount}
          showTrailingIcon={currentFilterCount < filterWithNames.length}
          filters={filterWithNames}
          setIsFiltersExpanded={setIsFiltersExpanded}
          onFilterRemove={onFilterRemove}
        />
      )}
    </>
  );
}

export default memo(AppliedFiltersV2);
